import { Box, Button, Chip, Paper, Stack, Typography } from "@mui/material";
import AddRounded from "@mui/icons-material/AddRounded";
import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";
import { colors } from "../constants/designTokens";

export function getDreSimulationTitle(version) {
  if (!version) return "";
  const month = version.mesAnoBase || version.mes_ano_base;
  const name = version.nomeVersao || version.nome_versao || "Simulacao";
  return month ? `${name} - ${month}` : name;
}

export default function DreSimulationHistoryPanel({
  versions = [],
  versionsStatus = "idle",
  selectedVersionId = "",
  onSelectVersion,
  onCreateVersion,
  createVersionLabel = "Criar nova simulacao",
  subtitle = "Versoes salvas para este empreendimento.",
}) {
  if (!versions.length) {
    return null;
  }

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        bgcolor: colors.surface,
        border: `1px solid ${colors.border}`,
        overflow: "hidden",
        textAlign: "left",
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", md: "center" }}
        spacing={1.2}
        sx={{ px: 2, py: 1.6, borderBottom: `1px solid ${colors.border}` }}
      >
        <Box>
          <Typography sx={{ color: colors.text, fontWeight: 900 }}>
            Historico de simulacoes
          </Typography>
          <Typography sx={{ color: colors.softMuted, fontSize: 12.5, mt: 0.35 }}>
            {subtitle}
          </Typography>
        </Box>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ xs: "stretch", sm: "center" }}>
          {onCreateVersion ? (
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddRounded />}
              onClick={onCreateVersion}
            >
              {createVersionLabel}
            </Button>
          ) : null}
          <Chip
            label={versionsStatus === "loading" ? "Atualizando" : `${versions.length} salva(s)`}
            size="small"
            sx={{ bgcolor: "#eef4ff", color: colors.primary, fontWeight: 800 }}
          />
        </Stack>
      </Stack>

      <Stack spacing={1.2} sx={{ p: 2 }}>
        {versions.map((version) => {
          const selected = String(version.id) === String(selectedVersionId);
          const title = getDreSimulationTitle(version);
          const description = version.descricao || version.descricaoVersao || "Sem descricao";
          const month = version.mesAnoBase || version.mes_ano_base || "Mes base nao informado";

          return (
            <Stack
              key={version.id}
              role="button"
              tabIndex={0}
              direction="row"
              spacing={1.4}
              alignItems="flex-start"
              onClick={() => onSelectVersion?.(String(version.id))}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onSelectVersion?.(String(version.id));
                }
              }}
              sx={{
                p: 1.5,
                borderRadius: 2.2,
                border: `1px solid ${selected ? "#9bd8bf" : "#b7caff"}`,
                bgcolor: selected ? "var(--ac-highlight-emerald, #f5fcf8)" : "var(--ac-highlight-blue, #f3f7ff)",
                cursor: "pointer",
                transition: "all 0.25s ease",
                outline: "none",
                "&:hover": {
                  borderColor: selected ? "#08765c" : colors.primary,
                },
                "&:focus-visible": {
                  boxShadow: `0 0 0 3px rgba(37, 99, 235, 0.18)`,
                },
              }}
            >
              <Box sx={{ pt: 0.15, color: selected ? "#08765c" : colors.primary }}>
                <DescriptionOutlined fontSize="small" />
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ color: colors.text, fontWeight: 800, fontSize: 13.5 }}>
                  {title}
                </Typography>
                <Typography sx={{ color: colors.muted, fontSize: 12.5, mt: 0.35, lineHeight: 1.55 }}>
                  {description}
                </Typography>
                <Typography sx={{ color: colors.softMuted, fontSize: 12, mt: 0.35 }}>
                  Mes base: {month}
                </Typography>
              </Box>
              <Chip
                label={selected ? "Selecionada" : "Salva"}
                size="small"
                sx={{
                  alignSelf: "center",
                  bgcolor: selected ? "#d8f9e9" : "#eaf1ff",
                  color: selected ? "#08765c" : colors.primary,
                  fontWeight: 800,
                }}
              />
            </Stack>
          );
        })}
      </Stack>
    </Paper>
  );
}
